import API from "../http-common";

import { debugLog } from "../utils/debugUtils";

const getAll = () => {
	return API.get("/tutorials");
};

const get = (id) => {
	return API.get(`/tutorials/${id}`);
};

const create = (data) => {
	return API.post("/tutorials", data);
};

const update = (id, data) => {
	return API.put(`/tutorials/${id}`, data);
};

const remove = (id) => {
	return API.delete(`/tutorials/${id}`);
};

const removeAll = () => {
	return API.delete(`/tutorials`);
};

const findByTitle = (title) => {
	return API.get(`/tutorials?title=${title}`);
};

const TutorialService = {
	getAll,
	get,
	create,
	update,
	remove,
	removeAll,
	findByTitle,
};

export default TutorialService;
